import { Client } from "../../model/client-model";
import Tag from "antd/es/tag";
import Dropdown from "antd/es/dropdown";
import { Form, Modal, notification, Space } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Actions, ClientActionMenu } from "../../util/constant";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataMapSourceModel } from "../../model/data-map-source-model";
import { useLazyGetClientQuery, useLazyGetClientsQuery, useAddClientMutation, useUpdateClientMutation, useDeleteClientMutation, useCopyClientMutation, useScheduleClientMutation, useUnscheduleClientMutation } from "../../redux/api/clients";
import { useLazyGetDataMapSourceQuery, useSaveDataMapSourceMutation } from "../../redux/api/data-maps";
import { useLazyGetDepartmentClientQuery, useSaveDepartmentClientMutation } from "../../redux/api/departments";

type Props = {
  clients: Client[];
  handleClientAction: (action: string, client: Client) => void;
};

export const ClientList: React.FC<Props> = ({ clients, handleClientAction }): JSX.Element => {

    const handleClick = (e: any, client: Client) => {
        handleClientAction(e.key, client);
    }

     /**
     * Gets the menu items available to the client depending on its current state
     * 
     * @param scheduled if scheduled
     * @param payloadType the payload type (XML, JSON, PDF, etc)
     * @returns the menu items
     */
    const getMenuItems = (cronSchedule: string, scheduled: boolean | undefined, payloadType: string | undefined ): any[] => {
        
        const menuItems = [
            ClientActionMenu.updateMenu,
            ClientActionMenu.deleteMenu,
            ClientActionMenu.copyMenu,
            {type: 'divider'},
            ClientActionMenu.sourceDataMenu,
            payloadType === 'PDF' ? ClientActionMenu.pdfBuilderMenu : ClientActionMenu.dataMappingMenu,
            ClientActionMenu.scriptEditorMenu,
            {type: 'divider'},
            cronSchedule ? (!scheduled ? ClientActionMenu.scheduleMenu : ClientActionMenu.unscheduleMenu) : null,
            {type: 'divider'},
            ClientActionMenu.departmentMenu,
        ];

        return menuItems.filter(item => item !== null);
    }

    return <div>
        {clients.map((client) => (
            <div className="client-item" key={client.id}>
                <div>{client.id}</div>
                <div>{client.clientCode}</div>
                <div>{client.name}</div>
                <div>{client.cronSchedule}</div>
                <div>{client.payloadType}</div>
                <div>{client.sourceChannelType}</div>
                <div>{client.destinationChannelType}</div>
                <div>{client.scheduled ? <Tag color="green">Scheduled</Tag> : <Tag color="red">Unscheduled</Tag>}</div>
                <div style={{ textAlign: 'center' }}>
                    <Dropdown
                        trigger={['click']}
                        menu={{
                            items: getMenuItems(client.cronSchedule, client.scheduled, client.payloadType),
                            onClick: (key) => handleClick(key, client)
                        }}>
                        <div style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()}>
                            <Space>
                                <span className="dropdown-title">
                                    <BsThreeDotsVertical />
                                </span>
                            </Space>
                        </div>
                    </Dropdown>
                </div>
            </div>
        ))}
    </div>
}
        